import { eu_taxonomy_compliance_enum, eu_taxonomy_datasource_enum } from '@predium/enums';
import { useMemo } from 'react';
import useOrgPreferences from '@/hooks/useOrgPreferences';

/**
 * The EU Taxonomy compliance tiers that can actually occur for the org's current data source.
 *
 * DREES_UND_SOMMER only splits the stock into top-15% (COMPLIANT) vs. the rest (NON_COMPLIANT) and
 * never grants the top-30% MEETS_DNSH_CRITERIA tier, so that value is omitted for it. DEFAULT_INDEX
 * returns all tiers. Use this anywhere you enumerate compliance values for the user (filters, etc.)
 * so unreachable options aren't shown.
 */
export function useEuTaxonomyComplianceOptions(): eu_taxonomy_compliance_enum[] {
  const { orgPreferences } = useOrgPreferences();

  return useMemo(
    () =>
      Object.values(eu_taxonomy_compliance_enum).filter((compliance) => {
        if (orgPreferences.euTaxonomyDatasource === eu_taxonomy_datasource_enum.DREES_UND_SOMMER) {
          return compliance !== eu_taxonomy_compliance_enum.MEETS_DNSH_CRITERIA;
        }
        return true;
      }),
    [orgPreferences.euTaxonomyDatasource],
  );
}
